import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {PlaningDate} from '../../../../api/src/template/template.model';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';

import {LocaleService} from '../../../../../src/app/shared/services/locale.service';
import {TranslateService} from '@ngx-translate/core';
import { OwlDateTimeIntl, DateTimeAdapter } from '@danielmoncada/angular-datetime-picker';


@Component({
    selector: 'app-date-list-edit',
    templateUrl: './date-list-edit.component.html',
    styleUrls: ['./date-list-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DateListEditComponent implements OnInit {

  @Input() planingDate: PlaningDate;
  @Input() idx: number;
  @Input() isEditable = true;
  public dateRange;
  @Output() planingDateChange = new EventEmitter<PlaningDate>();
  @Output() addPlaningDate = new EventEmitter<any>();
  @Output() applyPlaningDate = new EventEmitter<any>();
  @Output() removePlaningDate = new EventEmitter<number>();
  @ViewChild('intervalsTooltipHandler', {static: true}) intervalsTooltip: NgbTooltip;

  constructor(
    owlDateTimeIntl: OwlDateTimeIntl,
    dateTimeAdapter: DateTimeAdapter<Date>,
    private translate: TranslateService,
    private localeService: LocaleService) {
    localeService.locale$.subscribe(locale => {
      owlDateTimeIntl.rangeFromLabel = this.translate.instant('From');
      owlDateTimeIntl.rangeToLabel = this.translate.instant('To');

      dateTimeAdapter.setLocale(locale.serverShort);
    });
  }

  ngOnInit() {
    this.dateRange = [new Date(this.planingDate.datefrom), new Date(this.planingDate.dateto)];
  }

  updateDateRange(tooltip: TemplateRef<NgbTooltip>): void {
    if (this.dateRange[0] === null || this.dateRange[1] === null) {
      this.applyPlaningDate.next(this.planingDate);
      this.intervalsTooltip.close();
      return;
    }
    const timeZoneInSec = new Date().getTimezoneOffset();
    this.planingDate.datefrom = this.dateRange[0].getTime() - (60 * 1000 * timeZoneInSec);
    this.planingDate.dateto = this.dateRange[1].getTime() - (60 * 1000 * timeZoneInSec);
    this.addPlaningDate.next(this.planingDate);
    this.applyPlaningDate.next(this.planingDate);
    this.intervalsTooltip.close();
  }
}

